import { render } from "./InvoicesSubmittedTable.vue?vue&type=template&id=3f0d7b3e"
import script from "./InvoicesSubmittedTable.vue?vue&type=script&lang=js"
export * from "./InvoicesSubmittedTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__